import React from 'react';
import { motion } from 'framer-motion';

const personas = [
  {
    id: 'developer',
    title: 'Developer',
    icon: '💻',
    description: 'View technical projects & code',
  },
  {
    id: 'recruiter',
    title: 'Recruiter/ Manager',
    icon: '💼',
    description: 'See work experience & skills',
  },
  {
    id: 'athlete',
    title: 'Athlete/ Enthusiast',
    icon: '⚽',
    description: 'Check achievements & activities (Coming Soon!)',
  },
];

const UserSelect = ({ onSelectPersona }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-pure-black flex flex-col items-center justify-center p-8"
    >
      <motion.h1
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        className="text-5xl font-semibold text-pure-white mb-16 tracking-tight"
      >
        Select User
      </motion.h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl w-full">
        {personas.map((persona, index) => (
          <motion.div
            key={persona.id}
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3 + index * 0.1, duration: 0.5 }}
            whileHover={{ scale: 1.05, boxShadow: '0 20px 40px rgba(0, 122, 255, 0.3)' }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onSelectPersona(persona.id)}
            className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 cursor-pointer transition-all duration-300 hover:bg-white/10 border border-white/10"
            data-testid={`user-card-${persona.id}`}
          >
            <div className="flex flex-col items-center text-center">
              <div className="text-7xl mb-6 bg-gradient-to-br from-white/20 to-white/5 w-24 h-24 rounded-2xl flex items-center justify-center">
                {persona.icon}
              </div>
              <h3 className="text-2xl font-semibold text-pure-white mb-2">
                {persona.title}
              </h3>
              <p className="text-gray-400 text-sm">
                {persona.description}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default UserSelect;
